import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Empty, Pagination } from "antd";
import { SearchOutlined, EnvironmentOutlined, AppstoreOutlined } from "@ant-design/icons";
import "./jobListingSearchResults.scss";
import JobListingSearchResultFilter from "../jobListingSearchResultFilter";
import useNuJobsStore from "../../../store/nujobs.store";
import JobListingSearchResultCards from "../jobListingSearchResultCards";
import { SUPPORTED_LOCATION, SUPPORTED_JOB_CATEGORY } from "../../../helper/categoryconstants";
import useSettingstore from "../../../store/settings.store";
import NuJobsSignedInFooter from "../../../components/nujobs/nuJobsSignedInFooter";

export default function JobListingSearchResults({ alreadyApplied, loggedIn, applyNowCallBackLoggedIn }) {
  const {
    getOSAllJds,
    openJds,
    totalOpenJds,
    lastJDsReq,
    currentSearch,
    searchMetaData,
  } = useNuJobsStore();
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterJson, setFilterJson] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const savedRequest = getSettingByKey("lastJDsReq");
    if (lastJDsReq == null && savedRequest?.value != null) {
      getOSAllJds(savedRequest.value);
    } else if (lastJDsReq != null) {
      addOrUpdateSetting({ key: "lastJDsReq", value: lastJDsReq });
    }
    // Retain the original mount-only restore behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (lastJDsReq) {
      form.setFieldsValue({
        keywords: lastJDsReq.keywords,
        category: lastJDsReq.category,
        location: lastJDsReq.city,
      });
    }
  }, [lastJDsReq, form]);

  const withSignedInDetails = (request) => {
    if (!loggedIn) return request;
    const userData = JSON.parse(localStorage.getItem("nujobsUserDetails") || "{}");
    return {
      ...request,
      pendingsync: JSON.parse(localStorage.getItem("NuJobsPendingSync") || "[]"),
      signedin: true,
      nujuid: userData.nujuid,
      nujoid: userData.nujoid,
    };
  };

  const handleUpdateFormSubmit = (values) => {
    const request = withSignedInDetails({
      ...filterJson,
      qhoid:lastJDsReq?.qhoid,
      companyname:lastJDsReq?.companyname,
      country: lastJDsReq?.country,
      category: values.category,
      pagenum: 1,
      maxPerPage: pageSize,
      keywords: values.keywords,
      city: values.location,
    });
    getOSAllJds(request);
    setCurrentPage(1);
  };

  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
    getOSAllJds(withSignedInDetails({
      ...currentSearch,
      pagenum: page,
      maxPerPage: newPageSize,
    }));
  };

  if (lastJDsReq == null) return null;

  const keywords = typeof lastJDsReq.keywords === "string"
    ? lastJDsReq.keywords.trim()
    : Array.isArray(lastJDsReq.keywords)
      ? lastJDsReq.keywords.join(", ")
      : "";
  const locations = Array.isArray(lastJDsReq.city)
    ? lastJDsReq.city
    : lastJDsReq.city ? [lastJDsReq.city] : [];
  const categories = Array.isArray(lastJDsReq.category)
    ? lastJDsReq.category
    : lastJDsReq.category ? [lastJDsReq.category] : [];

  const renderPagination = () => (
    <Pagination
      className="jobListing-pagination"
      current={currentPage}
      pageSize={pageSize}
      total={totalOpenJds || 0}
      onChange={handlePageChange}
      showSizeChanger
      pageSizeOptions={[10, 20, 50, 100, 150]}
    />
  );
const getJobCategoryLabel = (value) => {
  return SUPPORTED_JOB_CATEGORY.find(
    (item) => item.value === value
  )?.label || value;
};
  return (
    <div className="jobListingSearchResults-wrapper">
      <section className="jobListingSearchResults-title">
        {lastJDsReq.companyname && (
          <div className="jobListing-company-header">
            <div className="jobListing-company-heading">
              <span className="company-heading-accent" />
              <h2>
                <span className="company-name">{lastJDsReq.companyname}</span>
                <span className="company-jobs-label"> Jobs</span>
              </h2>
            </div>
          </div>
        )}

        <div className="jobListing-search-summary">
          <div className="jobListing-summary-heading">
            <span className="jobListing-summary-caption">Search results</span>
            {keywords ? `“${keywords}”` : "Any Keyword"}
          </div>
          <span className="jobListing-summary-count">
            <strong>{totalOpenJds || 0}</strong> jobs found
          </span>
        </div>

        <div className="jobListingSearchResults-search-wrapper">
          <Form
            className="jobListingSearchForm"
            name="jobListingSearchResults-search"
            autoComplete="off"
            onFinish={handleUpdateFormSubmit}
            form={form}
            initialValues={{
              keywords: lastJDsReq.keywords,
              category: lastJDsReq.category,
              location: lastJDsReq.city,
            }}
          >
            <div className="jobListing-search">
              <Form.Item name="keywords">
                <Input
                  className="jobListing-search-item"
                  placeholder="Job title, skill or keyword"
                  prefix={<SearchOutlined className="jobListing-field-icon" />}
                />
              </Form.Item>

              <div className="jobListing-select-with-icon">
                <EnvironmentOutlined className="jobListing-field-icon" />
                <Form.Item name="location">
                  <Select
                    mode="multiple"
                    size="large"
                    maxTagCount={2}
                    placeholder="Any Location"
                    allowClear
                    className="jobListing-search-item"
                    options={SUPPORTED_LOCATION}
                  />
                </Form.Item>
              </div>

              <div className="jobListing-select-with-icon">
                <AppstoreOutlined className="jobListing-field-icon" />
                <Form.Item
                  name="category"
                  rules={[{ required: true, message: "Kindly Select at least one Category" }]}
                >
                  <Select
                    mode="multiple"
                    size="large"
                    maxTagCount={2}
                    className="jobListing-search-item"
                    placeholder="Any Category"
                    options={SUPPORTED_JOB_CATEGORY}
                    allowClear
                  />
                </Form.Item>
              </div>

              <Form.Item>
                <Button className="jobListing-search-button" htmlType="submit" icon={<SearchOutlined />}>
                  Search Again
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>

        {(keywords || locations.length > 0 || categories.length > 0) && (
          <div className="jobListing-active-criteria">
            <span className="jobListing-criteria-label">Your search:</span>
            {keywords && <span className="jobListing-criteria-chip">{keywords}</span>}
            {locations.map((location, index) => (
              <span className="jobListing-criteria-chip" key={`location-${index}`}>
                <EnvironmentOutlined /> {location}
              </span>
            ))}
            {categories.map((category, index) => (
              <span className="jobListing-criteria-chip" key={`category-${index}`}>
                <AppstoreOutlined /> {getJobCategoryLabel(category)}
              </span>
            ))}
          </div>
        )}
      </section>

      {renderPagination()}

      <div className="jobListing-Results">
        <Button className="mobile-filter-button" onClick={() => setShowFilters((prev) => !prev)}>
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
        <div className={`jobListing-filters ${showFilters ? "filters-visible" : ""}`}>
          <JobListingSearchResultFilter
            currentPageNumber={currentPage}
            maxPerPage={pageSize}
            filterJsonCallback={setFilterJson}
            loggedIn={loggedIn}
          />
        </div>
        <div className="jobListing-cards">
          {openJds?.length > 0 ? (
            openJds.map((jd, idx) => (
              <JobListingSearchResultCards
                key={jd.qhglobaljid || jd.qhcompanyjid || idx}
                alreadyApplied={alreadyApplied}
                openJd={jd}
                source={loggedIn ? "search" : "opensearch"}
                jdMetaData={searchMetaData?.[idx]}
                idx={idx}
                loggedIn={loggedIn}
                applyNowCallBackLoggedIn={applyNowCallBackLoggedIn}
                currentPage={currentPage}
              />
            ))
          ) : (
            <Empty className="jobListing-empty" />
          )}
        </div>
      </div>

      {renderPagination()}
      {loggedIn && <NuJobsSignedInFooter />}
    </div>
  );
}
